<template>
	<u-animate-container>
		<div class="about">
			<div class="container-fluid pb-5 container-top">
				<div class="container p-0">
					<b-row>
						<b-col cols="12" class="text-center pt-5 mt-5 p-0">
				    		<h1 class="section-title">{{configs['about_title']}}</h1>
							<b-col md="8" offset-md="2">
								<p v-html="configs['about_welcome_txt']"></p>
							</b-col>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="container content position-relative space-to-footer">
				<u-animate
			      name="fadeInUp"
				  :offset="0"
				  delay="0s" 
			      duration="1.2"
				  :begin="true" 
			      :iteration="1"
			    >
			    	<b-row>
						<b-col lg="8" cols="12" offset-lg="2">
							<div>
								<h3 class="section-title line-up-dark d-inline-block align-top">
									{{configs['about_intro_title']}}
								</h3>
								<p class="mt-2" v-html="configs['about_intro_text']"></p>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col lg="8" cols="12" offset-lg="2" class="mt-5">
							<div>
								<h3 class="section-title line-up-dark d-inline-block align-top">
									{{configs['about_values']}}
								</h3>
							</div>
							<div class="container">
								<b-row>
									<b-col class="p-0">
										<b-row class="pt-3">
											<b-col cols="12" md="6">
												<h5 class="section-title">{{configs['about_values_vision_title']}}</h5>
												<p>{{configs['about_values_vision_text']}}</p>
											</b-col>
											<b-col cols="12" md="6">
												<h5 class="section-title">{{configs['about_values_mission_title']}}</h5>
												<p>{{configs['about_values_mission_text']}}</p>
											</b-col>
										</b-row>
									</b-col>
								</b-row>
							</div>
						</b-col>
					</b-row>
					<b-row v-for="(item, idx) in themes" :key="idx">
						<b-col lg="8" cols="12" offset-lg="2" class="mt-5">
							<!-- <div :class="item.opened ? 'opened' : ''" class="text-lg-left text-center"> -->
							<div :class="item.opened ? 'opened' : ''" class="">
								<div v-on:click="item.opened = !item.opened">
									<h3 class="section-title line-up-dark d-inline-block align-top cursor-pointer" >
										{{item.title}} <i class="rotate-icon position-relative font-size-20 font-size-md-16 mt-md-2 mt-1 fa fa-sort-down align-middle d-inline-block align-top"></i>
									</h3>
								</div>
								<div class="ani-height-container mt-2"  :class="(isIE) ? 'no_animate' : ''" :style="'max-height: ' +((item.opened) ? item.height : 0) +'px;'">
									<div class="container">
										<b-row>
											<b-col class="p-0">
												<component :is="item.component" v-bind:params="item.params"></component>
											</b-col>
										</b-row>
									</div>
								</div>
							</div>
						</b-col>
					</b-row>
				</u-animate>
			</div>
		<Footer></Footer>
		</div>
	</u-animate-container>
</template>
<script>

export default {
  name: 'about',
  components: {
	Team: () => import('@/components/about/Team.vue'),
	History: () => import('@/components/about/History.vue'),
	Statutes: () => import('@/components/about/Statutes.vue'),
	StrategicPrinciples: () => import('@/components/about/StrategicPrinciples.vue'),
  },
  data() {
  	return {
		/*active_idx: -1,*/
  		themes: this.configs['about_themes']
  	}
  },
  methods: {

  },
  /*computed: {
		opened_items: function() {
			return this.active_idx > -1;
		}	
  }*/
  created: function()  {
		
	}
}
</script>
<style scoped>
.container-top {
	background-image: url('../assets/images/003_BackgroundAboutUs.jpg');
}
.rotate-icon {
	overflow: hidden;
	transition: all 0.3s ease-in-out;
	transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
	top: -5px;
}
.opened .rotate-icon {
	transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
	/*font-size: 22px;*/
}
.ani-height-container {
    /*-webkit-transition: max-height .6s ease-in-out;
	-moz-transition: max-height .6s ease-in-out;
	-ms-transition: max-height .6s ease-in-out;
	-o-transition: max-height .6s ease-in-out;*/
	transition: max-height .4s ease-in-out;
    overflow: hidden;
}
.no_animate.ani-height-container {
	transition: all 0s ease-in-out;
}
/*.opened .ani-height-container {
	max-height: 800px;
}*/
/*@media screen and (max-width:767.98px) {
    .rotate-icon {
		
	}
}*/
</style>
<style>
.about-avatar {
	width: 100%;
	max-width: 80px;
	display: inline-block;
}
@media screen and (max-width:767.98px) {
    .about-avatar {
		max-width: 60px;
	}
}
</style>